import { lazy } from 'react';

import Loadable from 'components/Loadable';

const PropostaPublicaPage = Loadable(lazy(() => import('pages/public/PropostaPublicaPage')));

const PublicRoutes = {
  path: '/p',
  children: [
    {
      path: ':token',
      element: <PropostaPublicaPage />
    }
  ]
};

export default PublicRoutes;
